<template>
<div class=""></div>
</template>

<script>
export default {
  name: 'promo-code',
  data () {
    return {}
  }
}
</script>

<style scoped>

</style>
